import VDivider from './VDivider';
export { VDivider };
export default VDivider;
//# sourceMappingURL=index.js.map